module.exports = __webpack_public_path__ + "img/animated-logo-fixed.61e59459.png";